export function isRequestBoardLoading(columns) {
  return columns.some(column => column.isLoading)
}

// A column that sent nothing (excluded, not enabled yet) counts as reloaded.
export function isRequestBoardReloaded(results) {
  return !results.includes(false)
}
